// extracted by mini-css-extract-plugin
export default {"rootClassName":"upload-assinado-button"};